/** Safely coerce unknown to string — null / undefined / objects become empty string. */
export const str = (val: unknown): string =>
  val == null || typeof val === "object" ? "" : String(val);

/** Fallback placeholder used any time a field is missing, so tiles never lose a line. */
export const FALLBACK = "";

/** Coerce a value to a display string, falling back to a placeholder when empty. */
export const strOrFallback = (val: unknown): string => str(val) || FALLBACK;

export function formatMMDDYYYY(date: Date): string {
  const mm = String(date.getMonth() + 1).padStart(2, "0");
  const dd = String(date.getDate()).padStart(2, "0");
  const yyyy = date.getFullYear();

  return `${mm}/${dd}/${yyyy}`;
}